<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-lg="2"><vs-button color="danger" type="border" icon="keyboard_backspace"
                @click="goBack">Back</vs-button></vs-col>
            <vs-col vs-lg="8" vs-type="flex" vs-justify="center">
              <h3>Edit Dashboard</h3>
            </vs-col>
            <vs-col vs-lg="2"></vs-col>
          </vs-row>

          <vs-input class="w-full mb-4" label="Name" data-vv-as="Name" name="Name" v-model="form.name"
            v-validate="'required'" />
          <div class="text-center mb-2">
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('Name')">{{
              errors.first("Name")
              }}</span>
          </div>
          <vs-input data-vv-as="Description" name="Description" v-validate="'required'" class="w-full mb-4"
            label="Description" v-model="form.description" />
          <div class="text-center mb-2">
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('Description')">{{
              errors.first("Description")
              }}</span>
          </div>

          <label class="vs-input--label">Data set</label>


          <div class="vx-row mb-1 p-2">

            <div class="vx-col sm:w-1/2">
              <vs-input placeholder="Search" type="text" class="w-full" name="search_filter" v-model="search_filter"
                @keyup="updatePaginate" />
            </div>

          </div>
          <div class="vx-row mb-1  p-2">

            <div class="vx-col sm:w-1/2 w-full">

              <div class="vx-row mb-1 all_dashboard_rows"
                v-for="dashboard, index in filterBy(dataSets, search_filter, 'name')" v-show="setPaginate(index)">
                <div class="vx-col w-full">
                  <span>{{ dashboard.name }}</span>
                  <vs-radio class="ml-10" v-model="form.data_set_id" :vs-value="dashboard.data_set_id"></vs-radio>
                </div>
              </div>
            </div>

            <div class="text-center mb-1">
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('data_set_required')">{{
                errors.first("data_set_required")
                }}</span>
            </div>

          </div>
          <div class="vx-row mb-1  p-2">

            <div class="vx-col sm:w-1/2 w-full">

              <div class="pagination mb-1">
                <a href="#" class="btn btn-default" v-for="page_index in paginate_total"
                  @click.prevent="updateCurrent(page_index)">
                  {{ page_index }}
                </a>
              </div>

            </div>

          </div>


          <label class="vs-input--label">Dashboard HTML</label>
          <vs-textarea class="w-full mb-4" rows="10" v-model="form.dashboard" data-vv-as="Dashboard HTML"
            name="Dashboard HTML" v-validate="'required'" />
          <div class="text-center mb-2">
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('Dashboard HTML')">{{
              errors.first("Dashboard HTML")
              }}</span>
          </div>
          <label class="vs-input--label">Assign to roles (these roles can view it)</label>





          <v-select multiple name="role" label="role" :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="form.roleIds" />



          <div class=" mt-5">

            <label class="vs-input--label">Assign to users (override) — Tick on checkbox for specific people</label>


            <vs-row vs-w="12" class="mb-5">




              <vs-col :key="u.uuid" v-for="u in users" vs vs-lg="3" vs-sm="3" vs-xs="12" class="p-3">
                <vs-checkbox v-model="form.selected_elomark_users" :vs-value="u.id">
                  {{ u.first_name }} {{ u.surname }}
                </vs-checkbox>
              </vs-col>



            </vs-row>

          </div>



          <div class="text-center mt-5">
            <vs-button @click.prevent="validate">Save</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import vSelect from "vue-select";
import Vue2Filters from 'vue2-filters'
export default {
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      current: 1,
      paginate: 10,
      paginate_total: 0,
      search_filter: '',
      internal_dashboard_user_permission_elomark_user: [],
      dashboards: [],
      dataSets: [],
      roles: [],
      users: [],
      editing: false,
      form: { id: null, name: "", description: "", dashboard: "", data_set_id: null, roleIds: [], selected_elomark_users: [] },
    };
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    setPaginate: function (i) {
      if (this.current == 1) {
        return i < this.paginate;
      }
      else {
        return (i >= (this.paginate * (this.current - 1)) && i < (this.current * this.paginate));
      }
    },
    updateCurrent: function (i) {
      this.current = i;
    },
    updatePaginate: function () {
      this.current = 1;
      this.paginate_total = Math.ceil(document.querySelectorAll(".all_dashboard_rows").length / this.paginate);
    },
    api(path) { return this.$base_url + "/api/internal_dashboard/" + path; },
    loadRefs() {
      axios.get(this.api("list_internal_dashboard_data_sets")).then(r => { this.dataSets = r.data || []; this.paginate_total = Math.ceil(this.dataSets.length / this.paginate); }).catch(() => { });
      // ⚠ CONFIRM: roles list endpoint
      axios.get(this.$base_url + "/api/roles/all_roles").then(r => { this.roles = r.data && r.data.data ? r.data.data : (r.data || []); }).catch(() => { });
      // ⚠ CONFIRM: Elomark users list endpoint (is_client='n')
      axios.get(this.$base_url + "/api/elomark_users/fetch_all_elomark_users").then(r => { this.users = r.data || []; }).catch(() => { });
    },
    edit(d) {
      axios.get(this.api("edit_internal_dashboard_data/" + d)).then(r => {
        this.form = { id: r.data.dashboard.id, name: r.data.dashboard.name, description: r.data.dashboard.description, dashboard: r.data.dashboard.dashboard, data_set_id: r.data.dashboard.data_set_id, roleIds: r.data.roles, selected_elomark_users: r.data.elomark_users.map(u => u.id) };

      }).catch(() => { });
    },
    buildGrants() {
      const grants = [];
      (this.form.roleIds || []).forEach(rid => grants.push({ grantee_type: "role", grantee_id: rid.id, access: "allow" }));
      this.form.selected_elomark_users.forEach(uid => grants.push({ grantee_type: "user", grantee_id: uid, access: this.form.selected_elomark_users[uid] }));
      return grants;
    },
    validate() {
      this.errors.clear();
      this.$validator.validateAll().then(result => {


        if (
          this.form.data_set_id == null || this.form.data_set_id == '') {
          this.errors.add({
            field: "data_set_required",
            msg: "Please select one of the dashboard"
          });
          result = false;
        }

        if (result) {
          this.save()
        }
      })

    },
    save() {
      const item = {
        name: this.form.name,
        description: this.form.description,
        dashboard: this.form.dashboard,
        data_set_id: this.form.data_set_id,
        grants: this.buildGrants()
      };
      const path = "update_internal_dashboard";
      if (this.form.id) item.id = this.form.id;
      axios.post(this.api(path), { item }).then(() => {
        this.$vs.notify({ title: "Internal Dasboard", text: "The internal dashboard has been saved", color: "success" });
        this.$router.push("/manage_internal_dashboard")
      }).catch(() => this.$vs.notify({ title: "Error", text: "Could not save", color: "danger" }));



    },
   
     goBack: function() {
      this.$router.push("/manage_internal_dashboard")
    },
  },
  mounted() {
    this.loadRefs();
    this.edit(this.$route.params.dashboardId)
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.v-select-box {
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}



.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 4px 8px;
  text-decoration: none;
  border: 1px solid #ddd;
  /* Gray */
}
</style>